/**
 * PUBLIC route for certificate verification (guest-first, no account):
 * `/verify/<certId>` lives OUTSIDE the `/u/<n>` tree (allowlisted in the
 * root's beforeLoad and in u-router) because the link is shared outside the
 * app — a verifier has no reason to have a session.
 */
import { createRoute, useParams } from "@tanstack/solid-router";
import { rootRoute } from "@/routes/__root";
import { VerifyCertificateView } from "@/features/courses/components/certificates/verify-view";

function VerifyCertificatePage() {
  const params = useParams({ from: "/verify/$certId" });
  return <VerifyCertificateView certId={params().certId} />;
}

export const verifyCertificateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/verify/$certId",
  component: VerifyCertificatePage,
});
